export default "__VITE_ASSET__DyZhP2Aq__"